export const BASE_URL = 'https://api.nasa.gov/planetary/apod'
export const API_KEY = 'BbOd7itdaqu3JeebrNlQeJ875wSVwQ3msC8wiYxf'